import React from 'react'
import { Image } from '@/atoms/Image'
import { CaptionLG, CaptionXS } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { ContentInteraction, DiscoverItemInteraction } from '@/services/Analytics/ContentInteractions'
import { HeroBannerData } from '@/services/RecommendedBannerService/types'
import { BaseHeroBanner } from '@/views/WatchLandingView/RecommendedBannerCarousel/RecommendedBanner/BaseHeroBanner'

type GenericBannerProps = {
  banner: HeroBannerData
  itemIndex?: number
  createInteraction?: (banner: HeroBannerData, itemIndex: number) => DiscoverItemInteraction | null
  trackInteraction?: (interaction: ContentInteraction, allowAutoImpression?: boolean) => void
}

export const GenericBanner: React.FC<GenericBannerProps> = ({
  banner,
  itemIndex = 0,
  createInteraction,
  trackInteraction,
}) => {
  const { genericConfig } = banner

  const backdrop =
    genericConfig?.landscapeCloudinaryPath ||
    banner.project.title?.landscapeBackdrop?.cloudinaryPath ||
    banner.project.discoveryPosterLandscapeCloudinaryPath
  const mobileBackdrop =
    genericConfig?.cloudinaryPath ||
    banner.project.title?.portraitBackdrop?.cloudinaryPath ||
    banner.project.discoveryPosterCloudinaryPath

  const interaction = createInteraction?.(banner, itemIndex) ?? null

  return (
    <BaseHeroBanner
      recommendationId={banner.recommendationId}
      actionHref={genericConfig?.link ? genericConfig.link : `${paths.watch.index}/${banner.project.slug}`}
      altText={genericConfig?.cta || banner.flavorText || ''}
      backdrop={backdrop}
      mobileBackdrop={mobileBackdrop}
      interaction={interaction}
      trackInteraction={trackInteraction}
      infoSection={
        <div className="mx-auto flex h-full w-full flex-col items-start justify-end gap-2 px-4 pb-8 md:ml-[60px] md:w-[410px] md:justify-center md:px-0 md:pb-0 lg:ml-[76px] xl:ml-[104px] se:w-[300px] se:max-w-full">
          {banner?.genericConfig?.logoCloudinaryPath && (
            <Image
              alt={genericConfig?.cta || banner.flavorText || (banner.project.name as string)}
              className="mx-auto h-[80px] w-fit sm:h-[150px] md:mx-0 md:h-[120px] xl:h-[150px]"
              src={`${banner.genericConfig.logoCloudinaryPath}.webp`}
              height={150}
              width={270}
            />
          )}
          <CaptionXS weight="medium" className="sm:photon-caption-md md:text-bold w-full text-center md:text-left">
            {banner.flavorText}
          </CaptionXS>
          {genericConfig?.cta && (
            <div className="mx-auto rounded-lg bg-guild-gradient px-12 py-2 md:mx-0 lg:mt-6">
              <CaptionLG weight="bold" className="uppercase">
                {genericConfig.cta}
              </CaptionLG>
            </div>
          )}
        </div>
      }
    />
  )
}
